"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, Transition } from "@headlessui/react";
import { clx } from "@medusajs/ui";
import React, { Fragment, useEffect, useRef } from "react";
import useToggleState from "@lib/hooks/use-toggle-state";
import X from "@modules/common/icons/x";
import OptionSelect from "./option-select";
import MoneyClient from "../../../../components/MoneyClient";
import { normalizeCurrency, toCents } from "@lib/currency";
import { STORE_BASE_CURRENCY } from "@lib/config";
type MobileActionsProps = {
  product: any;
  options: Record<string, string>;
  updateOption: (id: string, value: string) => void;
  inStock: boolean;
  handleAddToCart: () => void;
  isAdding?: boolean;
  show: boolean;
  disabled?: boolean;
  allOptionsSelected: boolean;
  disabledValues?: (option: any) => string[];
};
const MobileActions: React.FC<MobileActionsProps> = t0 => {
  const $ = _c(94);
  const {
    product,
    options,
    updateOption,
    inStock,
    handleAddToCart,
    isAdding,
    show,
    disabled,
    allOptionsSelected,
    disabledValues
  } = t0;
  const {
    state,
    open,
    close
  } = useToggleState();
  const barRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const bar = barRef.current;
      if (!bar) {
        return;
      }
      const mq = typeof window !== "undefined" ? window.matchMedia("(max-width: 1023px)") : null;
      const apply = () => {
        if (mq && mq.matches && bar) {
          const h = bar.getBoundingClientRect().height;
          document.documentElement.style.setProperty("--product-mobile-bar-height", `${h}px`);
        } else {
          document.documentElement.style.removeProperty("--product-mobile-bar-height");
        }
      };
      const ro = new ResizeObserver(apply);
      ro.observe(bar);
      apply();
      mq?.addEventListener("change", apply);
      return () => {
        ro.disconnect();
        mq?.removeEventListener("change", apply);
        document.documentElement.style.removeProperty("--product-mobile-bar-height");
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const originalPrice = typeof product?.originalPrice === "number" ? product.originalPrice : typeof product?.price === "number" ? product.price : 0;
  const discountedPrice = typeof product?.discountedPrice === "number" ? product.discountedPrice : null;
  const hasDiscount = discountedPrice !== null && discountedPrice > 0 && discountedPrice < originalPrice;
  const finalPrice = hasDiscount ? discountedPrice : originalPrice;
  const t3 = typeof product?.currency === "string" ? product.currency : STORE_BASE_CURRENCY;
  let t4;
  if ($[2] !== t3) {
    t4 = normalizeCurrency(t3, STORE_BASE_CURRENCY);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const productCurrency = t4;
  let t5;
  if ($[4] !== product) {
    t5 = Array.isArray(product?.options) ? product.options : [];
    $[4] = product;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const productOptions = t5;
  const hasOptions = productOptions.length > 0;
  const needsOptionSelection = hasOptions && !allOptionsSelected;
  let t6;
  if ($[6] !== handleAddToCart || $[7] !== needsOptionSelection || $[8] !== open) {
    t6 = () => {
      if (needsOptionSelection) {
        open();
        return;
      }
      handleAddToCart();
    };
    $[6] = handleAddToCart;
    $[7] = needsOptionSelection;
    $[8] = open;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleCartClick = t6;
  let t7;
  if ($[10] !== allOptionsSelected || $[11] !== close || $[12] !== handleAddToCart) {
    t7 = () => {
      if (!allOptionsSelected) {
        return;
      }
      close();
      handleAddToCart();
    };
    $[10] = allOptionsSelected;
    $[11] = close;
    $[12] = handleAddToCart;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleDrawerAddToCart = t7;
  const t8 = !show;
  let t9;
  if ($[14] !== t8) {
    t9 = clx("lg:hidden fixed inset-x-0 bottom-0 z-40", {
      "pointer-events-none": t8
    });
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      paddingBottom: "max(12px, env(safe-area-inset-bottom))"
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== discountedPrice || $[18] !== finalPrice || $[19] !== hasDiscount || $[20] !== originalPrice || $[21] !== productCurrency) {
    t11 = hasDiscount && discountedPrice ? <><span className="text-[15px] leading-tight font-medium tracking-tight text-black"><MoneyClient amountCents={toCents(discountedPrice)} fromCurrency={productCurrency} /></span><span className="text-xs text-gray-400 line-through leading-tight"><MoneyClient amountCents={toCents(originalPrice)} fromCurrency={productCurrency} /></span></> : finalPrice > 0 ? <span className="text-[15px] leading-tight font-medium tracking-tight text-black"><MoneyClient amountCents={toCents(finalPrice)} fromCurrency={productCurrency} /></span> : null;
    $[17] = discountedPrice;
    $[18] = finalPrice;
    $[19] = hasDiscount;
    $[20] = originalPrice;
    $[21] = productCurrency;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <div className="flex flex-col justify-center shrink-0">{t11}</div>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = !!disabled || isAdding || !inStock;
  const t14 = inStock && !disabled && !isAdding ? "bg-black text-white active:scale-[0.98]" : "bg-gray-200 text-gray-400 cursor-not-allowed";
  let t15;
  if ($[25] !== t14) {
    t15 = clx("flex-1 h-12 flex items-center justify-center text-[11px] font-lealti-light tracking-widest uppercase transition-all duration-200 rounded-full min-w-0", t14);
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== allOptionsSelected || $[28] !== hasOptions || $[29] !== inStock || $[30] !== isAdding) {
    t16 = isAdding ? <span className="flex items-center gap-2"><svg className="animate-spin h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>Agregando</span> : !inStock ? "Sin stock" : hasOptions && !allOptionsSelected ? "Seleccionar talle" : "Agregar al carrito";
    $[27] = allOptionsSelected;
    $[28] = hasOptions;
    $[29] = inStock;
    $[30] = isAdding;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== handleCartClick || $[33] !== t13 || $[34] !== t15 || $[35] !== t16) {
    t17 = <button onClick={handleCartClick} disabled={t13} className={t15} data-testid="mobile-cart-button">{t16}</button>;
    $[32] = handleCartClick;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t12 || $[38] !== t17) {
    t18 = <div ref={barRef} className="bg-white border-t border-gray-100 shadow-[0_-1px_0_0_#f0f0f0,0_-8px_24px_rgba(0,0,0,0.06)]" data-testid="mobile-actions-bar"><div className="flex items-center gap-3 px-4 pt-3" style={t10}>{t12}{t17}</div></div>;
    $[37] = t12;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== show || $[41] !== t18) {
    t19 = <Transition as={Fragment} show={show} enter="transition ease-out duration-300" enterFrom="opacity-0 translate-y-full" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-200" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-full">{t18}</Transition>;
    $[40] = show;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t19 || $[44] !== t9) {
    t20 = <div className={t9}>{t19}</div>;
    $[43] = t19;
    $[44] = t9;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-gray-700/75 backdrop-blur-sm" /></Transition.Child>;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const t22 = product?.name || product?.title || "Opciones";
  let t23;
  if ($[47] !== t22) {
    t23 = <Dialog.Title className="text-base font-lealti font-medium text-black">{t22}</Dialog.Title>;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <X />;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== close) {
    t25 = <button onClick={close} className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-gray-200" data-testid="close-modal-button">{t24}</button>;
    $[50] = close;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t23 || $[53] !== t25) {
    t26 = <div className="flex items-center justify-between border-b border-gray-100 px-6 pb-4 pt-5">{t23}{t25}</div>;
    $[52] = t23;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== disabled || $[56] !== disabledValues || $[57] !== isAdding || $[58] !== options || $[59] !== productOptions || $[60] !== updateOption) {
    let t28;
    if ($[62] !== disabled || $[63] !== disabledValues || $[64] !== isAdding || $[65] !== options || $[66] !== updateOption) {
      t28 = option => {
        const candidates = [option?.name, option?.title, option?.id ? String(option.id) : undefined, option?._id ? String(option._id) : undefined].filter(_temp);
        const currentValue = candidates.map(key => options[key]).find(_temp2);
        const optTitle = option?.name || option?.title || "Opci\xF3n";
        return <OptionSelect key={String(option.id || option._id || option.name || option.title)} option={option as any} current={currentValue} updateOption={updateOption} title={optTitle} disabled={!!disabled || !!isAdding} disabledValues={disabledValues ? disabledValues(option) : []} />;
      };
      $[62] = disabled;
      $[63] = disabledValues;
      $[64] = isAdding;
      $[65] = options;
      $[66] = updateOption;
      $[67] = t28;
    } else {
      t28 = $[67];
    }
    t27 = productOptions.map(t28);
    $[55] = disabled;
    $[56] = disabledValues;
    $[57] = isAdding;
    $[58] = options;
    $[59] = productOptions;
    $[60] = updateOption;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[68] !== t27) {
    t28 = <div className="flex flex-col gap-6 px-6 py-6">{t27}</div>;
    $[68] = t27;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      paddingBottom: "max(24px, env(safe-area-inset-bottom))"
    };
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  const t30 = !!disabled || !allOptionsSelected || !inStock || !!isAdding;
  const t31 = allOptionsSelected && inStock && !disabled && !isAdding ? "bg-black text-white active:bg-gray-800" : "bg-gray-200 text-gray-400 cursor-not-allowed";
  let t32;
  if ($[71] !== t31) {
    t32 = clx("w-full h-[52px] flex items-center justify-center text-sm font-lealti-light tracking-widest uppercase transition-all duration-200 rounded-full", t31);
    $[71] = t31;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== inStock || $[74] !== isAdding) {
    t33 = isAdding ? <span className="flex items-center gap-2"><svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>Agregando...</span> : !inStock ? "Sin stock" : "Agregar al carrito";
    $[73] = inStock;
    $[74] = isAdding;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== handleDrawerAddToCart || $[77] !== t30 || $[78] !== t32 || $[79] !== t33) {
    t34 = <div className="px-5 pb-4 pt-2" style={t29}><button onClick={handleDrawerAddToCart} disabled={t30} className={t32} data-testid="mobile-drawer-cart-button">{t33}</button></div>;
    $[76] = handleDrawerAddToCart;
    $[77] = t30;
    $[78] = t32;
    $[79] = t33;
    $[80] = t34;
  } else {
    t34 = $[80];
  }
  let t35;
  if ($[81] !== t26 || $[82] !== t28 || $[83] !== t34) {
    t35 = <div className="fixed inset-0 z-10 flex items-end justify-center"><Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4" enterTo="opacity-100 translate-y-0" leave="ease-in duration-200" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-4"><Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-t-2xl bg-white text-left shadow-xl" data-testid="mobile-actions-modal">{t26}{t28}{t34}</Dialog.Panel></Transition.Child></div>;
    $[81] = t26;
    $[82] = t28;
    $[83] = t34;
    $[84] = t35;
  } else {
    t35 = $[84];
  }
  let t36;
  if ($[85] !== close || $[86] !== t35) {
    t36 = <Dialog as="div" className="relative z-[75]" onClose={close}>{t21}{t35}</Dialog>;
    $[85] = close;
    $[86] = t35;
    $[87] = t36;
  } else {
    t36 = $[87];
  }
  let t37;
  if ($[88] !== state || $[89] !== t36) {
    t37 = <Transition appear={true} show={state} as={Fragment}>{t36}</Transition>;
    $[88] = state;
    $[89] = t36;
    $[90] = t37;
  } else {
    t37 = $[90];
  }
  let t38;
  if ($[91] !== t20 || $[92] !== t37) {
    t38 = <>{t20}{t37}</>;
    $[91] = t20;
    $[92] = t37;
    $[93] = t38;
  } else {
    t38 = $[93];
  }
  return t38;
};
export default MobileActions;
function _temp(v) {
  return typeof v === "string" && v.length > 0;
}
function _temp2(val) {
  return typeof val === "string" && val.length > 0;
}